import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from 'ramda'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { products } from '../../../../../redux/products/action';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';
import { selectListItems } from '../../../../../redux/library/selector';
import { organizationUnits } from '../../../../../redux/organizationUnits/action';
import { selectOrganizationUnitsListItems } from '../../../../../redux/organizationUnits/selector';
import { vendors } from '../../../../../redux/vendors/action';
import { selectVendorsListItems } from '../../../../../redux/vendors/selector';
import { tags } from '../../../../../redux/tags/action';
import { customers } from '../../../../../redux/customers/action';
import { selectTagsListItems } from '../../../../../redux/tags/selector';
import { selectCustomersListItems } from '../../../../../redux/customers/selector';
import { selectAggregationPolicyQueryItems } from '../../../../../redux/aggregation-policies/selector';
import { aggregationPolicy } from '../../../../../redux/aggregation-policies/action';
import { deepCopy } from '../../../../../common/services/common.service';
import { selectAffiliatorsListItems } from '../../../../../redux/affiliators/selector';
import { selectDSAPAgenciesListItems } from '../../../../../redux/dsap-agencies/selector';
import { dsapAgencies } from '../../../../../redux/dsap-agencies/action';
import { affiliators } from '../../../../../redux/affiliators/action';
import AggregatePolicyComponent from '../components/aggregation-policy.component';
import { setDisplayText } from '../../../../../service/tag-names.service';


let currentChange: any = {}
const AggregationPolicie = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectAggregationPolicyQueryItems)
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const customerLists = useSelector(selectCustomersListItems)
  const organizationUnitsLists = useSelector(selectOrganizationUnitsListItems)
  const libraryData = useSelector(selectListItems)
  const tagsLists = useSelector(selectTagsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const itemsData = useSelector(selectAffiliatorsListItems)
  const AgenciesData = useSelector(selectDSAPAgenciesListItems)
  const [selectedAggregationPolicy, setSelectedAggregationPolicy] = useState<any>({
    LimitedToOrganizationUnitIds: [],
    Inclusions: {
    },
    Exclusions: {
    },
    Aggregations: [{
    }],
    IsActive: true,
    AlwaysOn: true,
  })

  const [selectedAggregationPolicyDetails, setSelectedAggregationPolicyDetails] = useState<any>([])
  const [selectedAggregationPolicyDetailItems, setSelectedAggregationPolicyDetailItems] = useState([]);
  const [mediaFiles, setMediaFiles] = useState<any>([])
  const [openFile, setOpenFile] = useState<any>([]);
  const [programImageIndex, setprogramImageIndex] = useState<any>([])

  const fetchProgramyId = () => {
    dispatch(aggregationPolicy.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/market-place-policy/aggregation-policies/query`,
      entity: 'aggregationPolicy',
      jsonData: {
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  useEffect(() => {
    dispatch(tags.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/tag/tag-name/query-by-tag-name-list-value`,
      entity: 'tags',
      jsonData: {}
    })).then(() => {
      dispatch(dsapAgencies.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/dsap/agencies/list`,
        entity: 'dsapAgencies',
        jsonData: {}
      }))
    }).then(() => {
      dispatch(affiliators.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/dsap/agents/list`,
        entity: 'affiliators',
        jsonData: {}
      }))
    }).then(() => {
      dispatch(customers.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/customers/list`,
        entity: 'customers',
        jsonData: {}
      }));
    }).then(() => {
      dispatch(organizationUnits.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,
        entity: 'organizationUnits',
        jsonData: {}
      }))
    }).then(() => {
      if (parmas?.id > 0) {
        fetchProgramyId()
        setIsLoading(false)
      } else {
        const localSelectedTierprices = addNewTierPriceValuesRow({ selectedTierPriceValuesArg: selectedAggregationPolicyDetails });
        setSelectedAggregationPolicyDetails(localSelectedTierprices)
        const localSelectedTierPrice = addNewTierPricesRow({ selectedTierPriceFilesArg: selectedAggregationPolicyDetailItems, tierprice: selectedAggregationPolicyDetails, idx1: 0 });
        setSelectedAggregationPolicyDetailItems(localSelectedTierPrice)
        // const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        // setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
    })
  }, []
  )

  useEffect(
    () => {
      if (isQuery) {
        setSelectedAggregationPolicy(queryItems?.result?.items)
        // const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryItems?.result?.items?.MediaMappings?.MediaFiles });
        // setMediaFiles(localSelectedMedia)
        const brandData: any = queryItems?.result?.items?.Aggregations?.map((item: any) => {
          const itemData = {
            EntityId: item?.SourceEntity?.Id,
            Name: item?.SourceEntity?.Name,
            EntityTypeId: item?.SourceEntity?.EntityTypeId,
            Price: item?.SourceEntity?.Price,
            ReferralFee: item?.SourceEntity?.ReferralFee,
            ClosingFee: item?.SourceEntity?.ClosingFee,
            Aggregations: item?.Aggregations?.map((logoItem: any) => {
              return {
                "Id": logoItem?.Id,
                "Name": logoItem?.Name,
                "EntityTypeId": logoItem?.EntityTypeId,
                "Price": logoItem?.Price,
                "ReferralFee": {
                  "Percentage": logoItem?.ReferralFee?.Percentage,
                  "Cost": logoItem?.ReferralFee?.Cost
                },
                "ClosingFee": {
                  "Percentage": logoItem?.ClosingFee?.Percentage,
                  "Cost": logoItem?.ClosingFee?.Cost
                },
              };
            }),
          }
          return itemData
        })
        const localSelectedTierprices = addNewTierPriceValuesRow({ selectedTierPriceValuesArg: brandData });
        setSelectedAggregationPolicyDetails(localSelectedTierprices)

        const updatedTierPrice = brandData?.map((tierPriceValue: any, index: any) => {
          const localSelectedlogo = addNewTierPricesRow({
            selectedTierPriceFilesArg: tierPriceValue?.Aggregations,
            tierprice: localSelectedTierprices,
            idx: tierPriceValue?.Aggregations.length,
            idx1: index
          });
          return localSelectedlogo;
        });

        setSelectedAggregationPolicyDetailItems(updatedTierPrice)
      }

      [isQuery]
    }
  )

  const handleFormChange: any = ({ field, value }: any) => {
    currentChange = { value, field, idx: 0 }
    setSelectedAggregationPolicy({ ...selectedAggregationPolicy, [field]: value })
  }

  const handleInnerFormChange: any = ({ value, field, data }: any) => {
    currentChange = { value, field, data, idx: 0 }
    const fields = R.split(
      '.',
      field
    );
    const valueData = { ...data, [fields[1]]: value }// inner data update
    setSelectedAggregationPolicy({ ...selectedAggregationPolicy, [fields[0]]: valueData });
  }

  // const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
  //   const localSelectedmedia = deepCopy(selectedMediaFilesArg)
  //   const newsSelectedMedia = {
  //     Id: 0,
  //     FileTypeId: 0,

  //     OwnerId: parmas?.id,
  //     FileMappingURL: ''
  //   }
  //   if (localSelectedmedia.length === 0 ||
  //     localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
  //   ) {
  //     localSelectedmedia?.push(newsSelectedMedia)
  //   }

  //   return localSelectedmedia
  // }
  const setCombinationmediaInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    // localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setprogramImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'aggregationpolicy',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {
    mediaFiles[programImageIndex].FileMappingURL = data
    // const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    // setMediaFiles(localSelectedMedia)
  }

  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
  }

  const handleFormMediaChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )
    selectedAggregationPolicyDetails.splice(selectedAggregationPolicyDetails.length - 1, 1);
    const brandData: any = selectedAggregationPolicyDetails?.map((item: any) => {
      item?.Aggregations?.splice(item?.Aggregations.length - 1, 1);
      const itemData = {
        SourceEntity: {
          Id: item?.EntityId || 0,
          Name: item?.Name || 'String',
          EntityTypeId: selectedAggregationPolicy?.AggregationTypeId,
          EntityType: selectedAggregationPolicy?.AggregationTypeId === 1005
            ? 'DSAP Agent'
            : selectedAggregationPolicy?.AggregationTypeId === 1004
              ? 'DSAP Agency'
              : '',
          Price: item?.Price || 0,
          ReferralFee: {
            Percentage: 0,
            Cost: 0
          },
          ClosingFee: {
            Percentage: 0,
            Cost: 0
          }
        },

        Aggregations: item?.Aggregations?.map((logoItem: any) => {
          return {
            Id: logoItem?.Id || 0,
            Name: logoItem?.Name || item?.Name || 'string',
            EntityType: selectedAggregationPolicy?.AggregationTypeId === 1005
              ? 'DSAP Agent'
              : selectedAggregationPolicy?.AggregationTypeId === 1004
                ? 'DSAP Agency'
                : '',
            EntityTypeId: selectedAggregationPolicy?.AggregationTypeId || 0,
            Price: logoItem?.Price || 0,
            ReferralFee: {

              Percentage: logoItem?.['ReferralFee.Percentage'] || logoItem?.ReferralFee?.Percentage || 0,
              Cost: logoItem?.['ReferralFee.Cost'] || logoItem?.ReferralFee?.Cost || 0,
            },
            ClosingFee: {
              Percentage: logoItem?.['ClosingFee.Percentage'] || logoItem?.ClosingFee?.Percentage || 0,
              Cost: logoItem?.['ClosingFee.Cost'] || logoItem?.ClosingFee?.Cost || 0,
            }
          };
        }),
      }
      return itemData
    })

    const programData = {
      "Id": selectedAggregationPolicy?.Id,
      "AlwaysOn": selectedAggregationPolicy?.AlwaysOn,
      "IsActive": selectedAggregationPolicy?.IsActive,
      "Name": selectedAggregationPolicy?.Name,
      "Description": selectedAggregationPolicy?.Description,
      "StartDateUtc": selectedAggregationPolicy?.StartDateUtc,
      "EndDateUtc": selectedAggregationPolicy?.EndDateUtc,
      "Remarks": selectedAggregationPolicy?.Remarks,
      "AggregationTypeId": selectedAggregationPolicy?.AggregationTypeId,
      "DisplayOrder": selectedAggregationPolicy?.DisplayOrder,
      "Inclusions": selectedAggregationPolicy?.Inclusions,
      "Exclusions": selectedAggregationPolicy?.Exclusions,
      "LimitedToOrganizationUnitIds": selectedAggregationPolicy?.LimitedToOrganizationUnitIds,
      "Aggregations": brandData
    }
    if (parmas?.id > 0) {
      console.log(programData, 'programData')
      await dispatch(aggregationPolicy.resetAction({ actionType: 'update' }))
      await dispatch(aggregationPolicy.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/market-place-policy/aggregation-policies`,
        entity: 'aggregationPolicy',
        jsonData: {
          Records: [
            programData
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(aggregationPolicy.resetAction({ actionType: 'create' }))
      await dispatch(aggregationPolicy.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/market-place-policy/aggregation-policies`,
        entity: 'aggregationPolicy',
        jsonData: {
          Records: [
            programData
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/agencies/policies/aggregation')
  }
  const addNewTierPriceValuesRow = ({ selectedTierPriceValuesArg }: any) => {
    console.log(selectedTierPriceValuesArg, 'selectedTierPriceValuesArg')
    const localSelectedTierPriceValues = deepCopy(selectedTierPriceValuesArg);
    const newTierPriceValue = {

      SourceEntity: {
        Id: 0,
        Name: " ",
        EntityTypeId: 0,
        Price: 0,
        ReferralFee: {
          Percentage: 0,
          Cost: 0
        },
        ClosingFee: {
          Percentage: 0,
          Cost: 0
        }
      },
      Aggregations: [
        {
          "Id": 0,
          "Name": "string",
          "EntityTypeId": 0,
          "Price": 0,
          "ReferralFee": {
            "Percentage": 0,
            "Cost": 0
          },
          "ClosingFee": {
            "Percentage": 0,
            "Cost": 0
          }
        }
      ]
    };
    if (
      localSelectedTierPriceValues.length === 0 ||
      localSelectedTierPriceValues[localSelectedTierPriceValues?.length - 1]
        ?.EntityTypeId !== 0
    ) {
      localSelectedTierPriceValues?.push(newTierPriceValue);
    }

    return localSelectedTierPriceValues;
  };
  const handleFormTierPriceItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(selectedAggregationPolicyDetails); // deep copy of items
    let item = items[idx]; // deep copy of item to be edited
    item = { ...item, [field]: value }; // updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx };
    setSelectedAggregationPolicyDetails(items);
  };
  const setTierPriceValuesInfo = async () => {
    let localTierPriceValues = deepCopy(selectedAggregationPolicyDetails);
    localTierPriceValues.splice(currentChange.idx, 1, {
      ...localTierPriceValues[currentChange.idx],
    });
    localTierPriceValues = addNewTierPriceValuesRow({
      selectedTierPriceValuesArg: localTierPriceValues,
    });
    currentChange.field = 'EntityIdDONE';
    setSelectedAggregationPolicyDetails(localTierPriceValues);
  };
  const addNewTierPricesRow = ({ selectedTierPriceFilesArg, tierprice, idx, idx1 }: any) => {
    const localSelectedlogo = deepCopy(selectedTierPriceFilesArg)
    const newSelectedTierPrice = {
      Id: 0,
      Name: "",
      EntityTypeId: 0,
      Price: 0,
      ReferralFee: {
        Percentage: 0,
        Cost: 0
      },
      ClosingFee: {
        Percentage: 0,
        Cost: 0
      }

    }

    if (localSelectedlogo?.length === 0 ||
      tierprice[idx1]?.Aggregations[tierprice[idx1].Aggregations?.length - 1]?.Price !== 0
    ) {

      tierprice[idx1]?.Aggregations?.push(newSelectedTierPrice)
    }

    return localSelectedlogo
  }
  const handleFormTierPriceChange = ({ value, field, idx, cardValue, idx1 }: any) => {

    const items = deepCopy(cardValue.Aggregations);
    items[idx] = { ...items[idx], [field]: value };
    setSelectedAggregationPolicyDetailItems(items);
    const updatedCardValue: any = [...selectedAggregationPolicyDetails];
    updatedCardValue[idx1] = { ...cardValue, Aggregations: items };
    currentChange = { value, field, idx, cardValue, idx1 };
    setSelectedAggregationPolicyDetails(updatedCardValue);

  }
  const setCombinationTierPriceInfo = async () => {

    let localSelectedTierPrice = deepCopy(selectedAggregationPolicyDetailItems)
    localSelectedTierPrice.splice(
      currentChange.idx1,
      1,
      { ...localSelectedTierPrice[currentChange.idx1] }
    );

    localSelectedTierPrice = addNewTierPricesRow({ selectedTierPriceFilesArg: localSelectedTierPrice, tierprice: selectedAggregationPolicyDetails, idx1: currentChange.idx1 });
    currentChange.field = 'PriceDONE'
    setSelectedAggregationPolicyDetailItems(localSelectedTierPrice)
  }

  useEffect(
    () => {

      if (currentChange.field === 'Price') {
        setCombinationTierPriceInfo()
      }
    },
    [selectedAggregationPolicyDetailItems]
  )
  useEffect(() => {
    if (currentChange.field === 'EntityId') {
      setTierPriceValuesInfo();
    }
  }, [selectedAggregationPolicyDetails]);
  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setCombinationmediaInfo()
      }
    },
    [mediaFiles]
  )
  useEffect(
    () => {

    },
    [selectedAggregationPolicy]
  )

  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
        ownerId={parmas?.id}
      />}
      {isLoading ? <PageLoader /> :
        <AggregatePolicyComponent
          selectedTierPriceValues={selectedAggregationPolicyDetails}
          handleFormTierPriceItemChange={handleFormTierPriceItemChange}
          tierPriceItems={selectedAggregationPolicyDetailItems}
          onFormTierPriceIChange={handleFormTierPriceChange}
          changeImage={changeImage}
          handleClose={handleClose}
          mediaFiles={mediaFiles}
          onFormChange={handleFormChange}
          onFormItemChange={handleFormMediaChange}
          onFormSubmit={handleFormSubmit}
          selectedProgram={selectedAggregationPolicy}
          back={back}
          entityTypes={libraryData?.result?.EntityTypes}
          id={parmas?.id}
          onInnerFormChange={handleInnerFormChange}
          organizationUnits={organizationUnitsLists?.result?.items}
          allTags={setDisplayText(tagsLists?.result?.items)}
          customers={customerLists?.result?.items}
          setSelectedPolicyCollections={setSelectedAggregationPolicy}
          DSAPAgents={itemsData?.result?.items}
          DSAPAgencies={AgenciesData?.result?.items}
        />}
    </>
  )
}
export default AggregationPolicie;